/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import React, { useState, useEffect,useCallback,useMemo,useRef } from "react";
import { useParams,useLocation } from 'react-router-dom';
import ReactSpreadsheet from "react-spreadsheet"; 
import { APIEndpoint } from "../../../utils/axios";
import { useNavigate } from "react-router-dom";
import { formatDateByTimezone ,validateCellAndGetData} from "../../../utils/commonFunctions";
import * as ReactDOM from 'react-dom';
import { FaRegCheckSquare ,FaSave} from "react-icons/fa";
import { BiSolidSelectMultiple } from "react-icons/bi";
import { useTranslation } from "react-i18next";
import closeIcon from "../../../images/icons/Icon2.png"
import {LoaderPop} from '../../../common';
import { DEFAULT_SHEET_ROWS_PLIFERAGE } from "../../../utils/configs";
import moment from 'moment'
import { RiDeleteBin6Line } from "react-icons/ri";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const iIndexes = {
    ITEM_CODE: 0,
    ITEM_NAME: 1,
    AVAILABLE_STOCK: 2,
    ESTIMATED_QTY: 3,
    BOB: 4,
    CORPORATE: 5,
    WEB_MEAL: 6,
    ADJUSTMENTS:7,
    TOTAL: 8,
    TOTAL_WHOFFICER:9,
    TOTAL_CATOFFCR:10,
    UNIT: 11,
    REMARKS: 12,
};
const upliftsSheetLabels = ['Item Code', 'Item Name', 'Available Stock', 'Estimated Quantity', 'BoB', 'Corporate', 'Pre-booked','Adjustments','Total','Loaded from warehouse','Confirmed for uplift','Unit','Remarks'];


export const UpliftsItem = (props) => {
    const navigate = useNavigate();
    const urlParams = useParams();
  const { t } = useTranslation();
    const { state } = useLocation();
    const initLoad = useRef(true);
    const initLoadFilters = useRef(true);
    const { id, warehouseid, sectorid, dateid } = urlParams;
    const [upliftSheetData, setUpliftSheetData] = useState([]);
    const [upliftSheetDataMaster, setUpliftSheetDataMaster] = useState([]);
    const [itemMasterAll,setItemMasterAll] = useState([]);
    const [warehouseItemsFull, setWarehouseItemsFull] = useState([]);
    const [dateEdited,setDateEdited]=useState(null);
    const [message,setMessage]= useState({text:""});
    const [warehouseItemsFiltered, setWarehouseItemsFiltered] = useState([]);
    const [count, setCount] = useState(1);
    const [, setSelectedCellsArr] = useState([]);
    const [spreadsheetErrors, setSpreadsheetErrors] = useState([]);
    const [activeCell, setActiveCell] = useState([]);
    const [updatedItemsWithDutyFree,setUpdatedItemsDutyFree] = useState([]);
    const [activeCellsEdit,setActiveCellsEdit]=useState({bob:false,corp:false,webMeal:false,loadWhs:true,cnfrmUpift:true});
    const [filterItemsType, setFilterItemType] = useState({all:{checked:true,count:0},dutyPaid:{checked:false,count:0},dutyFree:{checked:false,count:0}});
    const [sectorName, setSectorName] = useState([]);
    const [loading, setLoading] = useState(false);
    const defaultCellFieldData = {
    id: 'id',
    value: '',
    defaultValue: '',
    className: 'cellClass',
    width: '200px',
    readOnly: false,
    type: 'string',
    required: true,
    showPopup: false
};


    useEffect( () => {
    if(initLoad.current)return;
        fetchItems();
        setSpreadsheetErrors([]);     
    }, [activeCellsEdit]);

useEffect(() => {
  getCellsAccess();
  if (warehouseid && state?.sectorName) {
    setSectorName(state.sectorName);
  }
}, [state, warehouseid]);

useEffect(() => {
  if (itemMasterAll.length && initLoadFilters.current && warehouseItemsFull.length>0) {   
             const itemMap = new Map(itemMasterAll.map(item => [item.itemId, item]));
            const updatedItemsWithDutyFree = warehouseItemsFull?.map(item => {
              const sourceItem = itemMap.get(item.itemId);
              return {
                ...item,
                dutyFree: sourceItem ? sourceItem.dutyFree : null 
              };
            });
if(updatedItemsWithDutyFree.length && filterItemsType.all.checked){
          setFilterItemType(prev=>{
        return {...prev,all:{...prev.all,count:updatedItemsWithDutyFree.length},dutyFree:{...prev.dutyFree,count:updatedItemsWithDutyFree.filter(item=>item.dutyFree).length},dutyPaid:{...prev.dutyPaid,count:updatedItemsWithDutyFree.filter(item=>!item.dutyFree).length}}
      })
      setUpdatedItemsDutyFree(updatedItemsWithDutyFree);
      initLoadFilters.current=false;
}
  }
}, [warehouseItemsFull,itemMasterAll]);

 const filteredItems = useMemo(() => {
    return filterItemsType.dutyFree.checked
      ? updatedItemsWithDutyFree.filter(item => item.dutyFree)
      : filterItemsType.dutyPaid.checked
      ? updatedItemsWithDutyFree.filter(item => !item.dutyFree)
      : updatedItemsWithDutyFree;
  }, [filterItemsType, updatedItemsWithDutyFree]);

  const options = useMemo(() => {
    return filteredItems.map((fieldValue, index) => [
      {
        id: 'itemCode',
        value: fieldValue.itemCode,
        className: 'cellClass1',
        width: '300px',
        showPopup: true,
        readOnly: false,
        required: true,
        type: "string"
      },
      {
        id: 'itemName',
        value: fieldValue.itemName,
        className: `cellClass cellClass_${index}_${iIndexes.ITEM_NAME}`,
        width: '400px',
        showPopup: true,
        readOnly: false,
        required: true,
        type: "string"
      },
      {
        id: 'availableStock',
        value: fieldValue.availableStock,
        className: `cellClass cellClass_${index}_${iIndexes.AVAILABLE_STOCK}`,
        width: '100px',
        readOnly: true
      },
      {
        id: 'estimatedQuantity',
        value: fieldValue.estimatedQuantity,
        className: `cellClass cellClass_${index}_${iIndexes.ESTIMATED_QTY}`,
        width: '100px',
        readOnly: true
      },
      {
        id: 'bob',
        value: fieldValue.bob ?? 0,
        className: `cellClass cellClass_${index}_${iIndexes.BOB}`,
        width: '100px',
        readOnly: activeCellsEdit.bob
      },
      {
        id: 'corporate',
        value: fieldValue.corporate ?? 0,
        className: `cellClass cellClass_${index}_${iIndexes.CORPORATE}`,
        width: '100px',
        readOnly: activeCellsEdit.corp
      },
      {
        id: 'webMeal',
        value: fieldValue.webMeal ?? 0,
        className: `cellClass cellClass_${index}_${iIndexes.WEB_MEAL}`,
        width: '200px',
        readOnly: activeCellsEdit.webMeal
      },
      {
        ...defaultCellFieldData,
        type: 'number',
        id: 'adjustments',
        value: fieldValue.others ?? 0,
        className: `cellClass cellClass_${index}_${iIndexes.ADJUSTMENTS}`,
        readOnly: true,
        required: true
      },
      {
        id: 'total',
        value: fieldValue.total,
        className: `cellClass cellClass_${index}_${iIndexes.TOTAL}`,
        width: '200px',
        readOnly: true
      },
      {
        id: 'totalByWarehouseOfficer',
        value: fieldValue.totalByWarehouseOfficer,
        className: `cellClass cellClass_${index}_${iIndexes.TOTAL_WHOFFICER}`,
        width: '200px',
        readOnly: activeCellsEdit.loadWhs
      },
      {
        id: 'totalByCateringOfficer',
        value: fieldValue.totalByCateringOfficer,
        className: `cellClass cellClass_${index}_${iIndexes.TOTAL_CATOFFCR}`,
        width: '200px',
        readOnly: activeCellsEdit.cnfrmUpift
      },
      {
        id: 'unit',
        value: fieldValue.unit,
        className: `cellClass cellClass_${index}_${iIndexes.UNIT}`,
        width: '200px',
        readOnly: true,
        required: true
      },
      {
        id: 'remarks',
        value: fieldValue.remarks,
        className: `cellClass cellClass_${index}_${iIndexes.REMARKS}`,
        width: '200px'
      }
    ]);
  }, [filteredItems, activeCellsEdit, iIndexes]);

  useEffect(() => {
    if (!initLoadFilters.current && updatedItemsWithDutyFree.length) {
      setUpliftSheetData(options);

      if (options.length) {
        const newRows = createEmptySheetRows(filteredItems.length, 10);
        setWarehouseItemsFiltered([...filteredItems, ...newRows]);
        setWarehouseItemsFull(filteredItems);
        setEditTransferItemsToSheet({ items: [...filteredItems] }, options);
      }
    }
  }, [options, filteredItems]);


const warehouseItemsMap = useMemo(() => {
  const map = {};
  warehouseItemsFull?.forEach(item => {
    map[item.itemCode] = item;
  });
  return map;
}, [warehouseItemsFull]);

  const fetchItemMasterAll = async (page = 1, perPage = 50) => {
    const filterData = {
      action: 4,
      collection: '',
      filterOperation: 'or',
      filters: [],
      limit: perPage,
      page: page,
      searchParam: ''
    };

    try{
      const res = await APIEndpoint.post('master/process', filterData);
      if(res){
      return res;
      }
    }
    catch(err){
      console.error('Error fetching item master:', err);
    }

  }

  async function getItemMasterAll() {
    try {
      const initialRes = await fetchItemMasterAll(1, 1);

      if (
        initialRes?.count &&
        Array.isArray(initialRes.items) &&
        initialRes.items.length 
      ) {
        const fullRes = await fetchItemMasterAll(1, initialRes.count);
        setItemMasterAll([...fullRes.items]);
        return true;
      }else{
        return false;
      }
    } catch (error) {
      return false;
    }
  }

const getCellsAccess = () => {
    const defaultState = (prev) => ({ ...prev });

    const editStates = {
        upliftCreated: defaultState,
        reviewRequestedFromCateringManager: () => ({
            bob: true,
            webMeal: true,
            corp: true,
            cnfrmUpift: true,
            loadWhs: false,
        }),
        awaitingItemScanAndLoad: () => ({
            bob: true,
            webMeal: true,
            corp: true,
            cnfrmUpift: true,
            loadWhs: false,
        }),
        awaitingItemProcessingAndLoading: () => ({
            bob: true,
            webMeal: true,
            corp: true,
            cnfrmUpift: false,
            loadWhs: true,
        })
    };

    const updater = editStates[state?.upliftData] || defaultState;
    setActiveCellsEdit((prev) => updater(prev));
    initLoad.current=false;
    getItemMasterAll().catch(err => console.error('Failed to load item master:', err));
};

      const showToast = useCallback(()=>{
            toast.dismiss();
    
            if (message.text) {
              toast.success(message.text, {
                position: toast.POSITION.TOP_CENTER,
                hideProgressBar: true,
                pauseOnHover: true,
                draggable: false,
                autoClose: 1800,
                style: {
                  backgroundColor: '#4cae4c',
                  color: '#fff',
                  borderRadius: '8px',
                  fontSize: '1rem',
                }
              });
            } else if (message.error) {
              toast.error(message.error, {
                position: toast.POSITION.TOP_CENTER,
                hideProgressBar: true,
                pauseOnHover: true,
                draggable: false,
                autoClose: 1800,
                style: {
                  backgroundColor: '#d9534f',
                  color: '#fff',
                  borderRadius: '8px',
                  fontSize: '1rem',
                  width:'30rem'
                }
              });
            } else {
    
            }
          },[message])


          useEffect(() => {
            if (!message.text && !message.error) return;
            showToast();
            const timer = setTimeout(() => {
              setMessage({ text: "" });
              if (message.error) navigate(-1);
            }, 2500);
          
            return () => clearTimeout(timer);
          }, [message.text, message.error,showToast]);

    const targetEltCodes = document.getElementsByClassName("cellSelectionBlockItemCodes")[0];
    const targetEltNames = document.getElementsByClassName("cellSelectionBlockItemNames")[0];
    const targetEltReasonTypes = document.getElementsByClassName("cellSelectionBlockReasonTypes")[0];


const checkSheetData=()=>{
    let data=false;
    upliftSheetData?.map(upl=>{
        upl?.forEach((val,ind)=>{
            if(val&&val?.value){
                data=true
            }
        })

    })
    return data
}
    const createEmptySheetRows = (addtionalRows=0,noOfRows = DEFAULT_SHEET_ROWS_PLIFERAGE) => {
        const rows = [];
        if(addtionalRows>0){
           let i=0;
            while(i<10) {
                rows.push([
                    {
                        ...defaultCellFieldData,
                        id: 'itemCode',
                        className: 'cellClass cellClass_' + addtionalRows + '_' + iIndexes.ITEM_CODE,
                        showPopup: true
                    },
                    {
                        ...defaultCellFieldData,
                        id: 'itemName',
                        className: 'cellClass cellClass_' + addtionalRows + '_' + iIndexes.ITEM_NAME,
                        showPopup: true
                    },
                    {
                        ...defaultCellFieldData,
                        id: 'availableStock',
                        className: 'cellClass cellClass_' + addtionalRows + '_' + iIndexes.AVAILABLE_STOCK,
                        width: '400px',
                        type:'number',
                        required:true,
                        readOnly: true,
                    },
                    {
                        ...defaultCellFieldData,
                        id: 'estimatedQuantity',
                        type:'number',
                        className: 'cellClass cellClass_' + addtionalRows + '_' + iIndexes.ESTIMATED_QTY,
                        width: '400px',
                        required:true,
                        readOnly: true,
                    },
                    {
                        ...defaultCellFieldData,
                        type:'number',
                        id: 'bob',
                        className: 'cellClass cellClass_' + addtionalRows + '_' + iIndexes.BOB,
                        readOnly: activeCellsEdit.bob,
                        required: true
                    },
                    {
                        ...defaultCellFieldData,
                        type:'number',
                        id: 'corporate',
                        className: 'cellClass cellClass_' + addtionalRows + '_' + iIndexes.CORPORATE,
                        readOnly:  activeCellsEdit.corp,
                        required: true
                    },
                    {
                        ...defaultCellFieldData,
                        type:'number',
                        id: 'webMeal',
                        className: 'cellClass cellClass_' + addtionalRows + '_' + iIndexes.WEB_MEAL,
                        readOnly:  activeCellsEdit.webMeal,
                        required: true
                    },
                       {
                        ...defaultCellFieldData,
                        type:'number',
                        id: 'adjustments',
                        className: 'cellClass cellClass_' + addtionalRows + '_' + iIndexes.ADJUSTMENTS,
                        readOnly: true,
                        required: true
                    },
                    {
                        ...defaultCellFieldData,
                        type:'number',
                        id: 'total',
                        className: 'cellClass cellClass_' + addtionalRows + '_' + iIndexes.TOTAL,
                        readOnly: false,
                        required: true
                    },

                    {
                        ...defaultCellFieldData,
                        type:'number',
                        id: 'totalByWarehouseOfficer',
                        className: 'cellClass cellClass_' + addtionalRows + '_' + iIndexes.TOTAL_WHOFFICER,
                        readOnly:  activeCellsEdit.loadWhs,
                        required: true
                    },
                    {
                        ...defaultCellFieldData,
                        type:'number',
                        id: 'totalByCateringOfficer',
                        className: 'cellClass cellClass_' + addtionalRows + '_' + iIndexes.TOTAL_CATOFFCR,
                        readOnly: activeCellsEdit.cnfrmUpift,
                        required: true
                    },
                    {
                        ...defaultCellFieldData,
                        id: 'unit',
                        className: 'cellClass cellClass_' + addtionalRows + '_' + iIndexes.UNIT,
                        readOnly: true,
                        required: true
                    },
                    {
                        ...defaultCellFieldData,
                        id: 'remarks',
                        required:false,
                        readOnly:false,
                        className: 'cellClass cellClass_' + addtionalRows + '_' + iIndexes.REMARKS,
                    },

                ]);
                i++;
                addtionalRows++;
            }

        }else{
            for( var i=0; i < noOfRows; i++) {
                rows.push([
                    {
                        ...defaultCellFieldData,
                        id: 'itemCode',
                        className: 'cellClass cellClass_' + i + '_' + iIndexes.ITEM_CODE,
                        showPopup: true
                    },
                    {
                        ...defaultCellFieldData,
                        id: 'itemName',
                        className: 'cellClass cellClass_' + i + '_' + iIndexes.ITEM_NAME,
                        showPopup: true
                    },
                    {
                        ...defaultCellFieldData,
                        id: 'availableStock',
                        className: 'cellClass cellClass_' + i + '_' + iIndexes.AVAILABLE_STOCK,
                        width: '400px',
                        type:'number',
                        required:true,
                        readOnly: true,
                    },
                    {
                        ...defaultCellFieldData,
                        id: 'estimatedQuantity',
                        type:'number',
                        className: 'cellClass cellClass_' + i + '_' + iIndexes.ESTIMATED_QTY,
                        width: '400px',
                        required:true,
                        readOnly: true,
                    },
                    {
                        ...defaultCellFieldData,
                        type:'number',
                        id: 'bob',
                        className: 'cellClass cellClass_' + i + '_' + iIndexes.BOB,
                        readOnly:  activeCellsEdit.bob,
                        required: true
                    },
                    {
                        ...defaultCellFieldData,
                        type:'number',
                        id: 'corporate',
                        className: 'cellClass cellClass_' + i + '_' + iIndexes.CORPORATE,
                        readOnly:  activeCellsEdit.corp,
                        required: true
                    },
                    {
                        ...defaultCellFieldData,
                        type:'number',
                        id: 'webMeal',
                        className: 'cellClass cellClass_' + i + '_' + iIndexes.WEB_MEAL,
                        readOnly:  activeCellsEdit.webMeal,
                        required: true
                    },
                    {
                        ...defaultCellFieldData,
                        type:'number',
                        id: 'adjustments',
                        className: 'cellClass cellClass_' + addtionalRows + '_' + iIndexes.ADJUSTMENTS,
                        readOnly: true,
                        required: true
                    },
                    {
                        ...defaultCellFieldData,
                        type:'number',
                        id: 'total',
                        className: 'cellClass cellClass_' + i + '_' + iIndexes.TOTAL,
                        readOnly: true,
                        required: true
                    },

                    {
                        id: 'totalByWarehouseOfficer',
                        className: 'cellClass cellClass_' + i + '_' + iIndexes.TOTAL_WHOFFICER,
                        width: '200px',
                        readOnly:  activeCellsEdit.loadWhs
                    },
                    {
                        id: 'totalByCateringOfficer',
                        className: 'cellClass cellClass_' + i + '_' + iIndexes.TOTAL_CATOFFCR,
                        width: '200px',
                        readOnly:  activeCellsEdit.cnfrmUpift
                    },
                    {
                        ...defaultCellFieldData,
                        id: 'unit',
                        className: 'cellClass cellClass_' + i + '_' + iIndexes.UNIT,
                        readOnly: true,
                        required: true
                    },
                    {
                        ...defaultCellFieldData,
                        id: 'remarks',
                        required:false,
                        readOnly:false,
                        className: 'cellClass cellClass_' + i + '_' + iIndexes.REMARKS,
                    },
                ]);
            }
        }

        return rows;
    }

function syncUpliftDataMaster(updatedData, deletedRowIndex = null) {
  setUpliftSheetDataMaster(prev => {
    const updatedMap = new Map(
      updatedData.map(row => {
        const itemCode = row.find(c => c.id === "itemCode")?.value;
        return [itemCode, row];
      })
    );

    let merged = prev
      .map(oldRow => {
        const itemCode = oldRow.find(c => c.id === "itemCode")?.value;
        if (updatedMap.has(itemCode)) {
          return [...updatedMap.get(itemCode)]; 
        }
        return oldRow; 
      });

    if (deletedRowIndex !== null) {
      const deletedItemCode = updatedData[deletedRowIndex]?.find(c => c.id === "itemCode")?.value;
      merged = merged.filter(row => row.find(c => c.id === "itemCode")?.value !== deletedItemCode);
    }

    return merged;
  });
}





    const addRowsToSheet = (rowsToAdd = 10) => {
        const newRows = createEmptySheetRows(upliftSheetData.length,10)
        if(newRows.length > 0 ){
            setUpliftSheetData(data=>[...data,...newRows])
                syncUpliftDataMaster([...upliftSheetData,...newRows],null);
        }
    };

const removeRow = () => {
  if (count % 2 === 0) {

    let updatedSheetData = upliftSheetData.map((row, rowIndex) =>
      row.map((cell, colIndex) => ({
        ...cell,
        value: '',
        className: `cellClass cellClass_${rowIndex}_${colIndex}`
      }))
    );

    setUpliftSheetData(updatedSheetData);
    syncUpliftDataMaster(upliftSheetData, null);

  } else {
    let rowIndex = activeCell.row;
    let updatedSheetData = upliftSheetData.filter((_, index) => index !== rowIndex);

    setUpliftSheetData(updatedSheetData);
    syncUpliftDataMaster(upliftSheetData, rowIndex);
  }
};


function handleTypeSelect(selected = null) {
  setFilterItemType((prev) => ({
    all: {
      ...prev.all,
      checked: selected === 'all',
    },
    dutyFree: {
      ...prev.dutyFree,
      checked: selected === 'dutyFree',
    },
    dutyPaid: {
      ...prev.dutyPaid,
      checked: selected === 'dutyPaid',
    },
  }));
}

    const findByIdData = async() => {
        const IdData = await APIEndpoint.get('uplifts/findById/'+id)
        setSectorName(`${IdData.result.store.flightNumber} (${IdData.result.store.originName}-${IdData.result.store.destinationName}) `)
        return IdData
    }

    const fetchItems = async () => {
        setLoading(true)
        let filter1,filter2;
if(urlParams["*"].includes('edituplift')){
     try {
        let IdData = await findByIdData();
        setDateEdited(IdData.result?formatDateByTimezone(IdData.result.targetDate):null);
        filter1 ={
            departureDate:formatDateByTimezone( IdData.result.targetDate),
            storeId: IdData.result.storeId,
            upliftId: id,
            warehouseId: IdData.result.warehouseId
        }
        filter2={departureDate:formatDateByTimezone( IdData.result.targetDate),
            operationDate: formatDateByTimezone( IdData.result.targetDate),
            storeId: IdData.result.storeId,
            warehouseId: IdData.result.warehouseId}

                const [respEnum,resPriceList,resPriceListEnum] = await Promise.all([
                    APIEndpoint.get('items/enumerate'),
                    APIEndpoint.post(`stores/pricelist/items`,filter1),
                    APIEndpoint.post(`stores/pricelist/items/enumerate`,filter2),
                ],

                );
                if(respEnum.success && resPriceList.success && resPriceListEnum.success && IdData.success){

                    const pList = resPriceList.items
                    .filter(item =>
                      respEnum.items.some(resI => resI.itemId === item.itemId)
                    )
                    .filter(item =>
                      resPriceListEnum.items.some(rIp => rIp.itemId === item.itemId)
                    )
                    .map(item => {
                      const idItem = IdData.result.items.find(it => it.itemCode === item.itemCode);

                      if (idItem) {
                        return {
                          ...item,
                          totalByCateringManager: idItem.reviewedByCateringManager?.total ?? null,
                          totalByWarehouseOfficer: idItem.scannedByWarehouseOfficer?.total ?? null,
                          totalByCateringOfficer: idItem.verifiedByCateringOfficer?.total ?? null,
                        };
                      }

                      return {
                        ...item,
                        totalByCateringManager: null,
                        totalByWarehouseOfficer: null,
                        totalByCateringOfficer: null,
                      };
                    });

        if(pList && pList.length){

             setLoading(false)
            const options = [];
            pList.filter( (fieldValue, index) => {
                options.push([
                    {
                        id: 'itemCode',
                        value: fieldValue.itemCode,
                        className: 'cellClass1',
                        width: '300px',
                        showPopup:true,
                        readOnly:false,
                        required:true,
                        type:"string"
                    },
                    {
                        id: 'itemName',
                        value: fieldValue.itemName,
                        className: `cellClass cellClass_${index}_${iIndexes.ITEM_NAME}`,
                        width: '400px',
                        showPopup:true,
                        readOnly:false,
                        required:true,
                        type:"string"
                    },
                    {
                        id: 'availableStock',
                        value: fieldValue.availableStock,
                        className: `cellClass cellClass_${index}_${iIndexes.AVAILABLE_STOCK}`,
                        width: '100px',
                        readOnly: true
                    },
                    {
                        id: 'estimatedQuantity',
                        value: fieldValue.estimatedQuantity,
                        className: `cellClass cellClass_${index}_${iIndexes.ESTIMATED_QTY}`,
                        width: '100px',
                        readOnly: true,
                    },
                    {
                        id: 'bob',
                        value: fieldValue.bob??0,
                        className: `cellClass cellClass_${index}_${iIndexes.BOB}`,
                        width: '100px',
                        readOnly:  activeCellsEdit.bob
                    },
                    {
                        id: 'corporate',
                        value: fieldValue.corporate??0,
                        className: `cellClass cellClass_${index}_${iIndexes.CORPORATE}`,
                        width: '100px',
                        readOnly:  activeCellsEdit.corp
                    },
                    {
                        id: 'webMeal',
                        value: fieldValue.webMeal??0,
                        className: `cellClass cellClass_${index}_${iIndexes.WEB_MEAL}`,
                        width: '200px',
                        readOnly:  activeCellsEdit.webMeal
                    },
                    {
                        ...defaultCellFieldData,
                        type:'number',
                        id: 'adjustments',
                        value: fieldValue.others??0,
                        className: `cellClass cellClass_${index}_${iIndexes.ADJUSTMENTS}`,
                        readOnly: true,
                        required: true
                    },
                    {
                        id: 'total',
                        value: fieldValue.total,
                        className: `cellClass cellClass_${index}_${iIndexes.TOTAL}`,
                        width: '200px',
                        readOnly: true
                    },

                    {
                        id: 'totalByWarehouseOfficer',
                        value: fieldValue.totalByWarehouseOfficer,
                        className: `cellClass cellClass_${index}_${iIndexes.TOTAL_WHOFFICER}`,
                        width: '200px',
                        readOnly:  activeCellsEdit.loadWhs
                    },
                    {
                        id: 'totalByCateringOfficer',
                        value: fieldValue.totalByCateringOfficer,
                        className: `cellClass cellClass_${index}_${iIndexes.TOTAL_CATOFFCR}`,
                        width: '200px',
                        readOnly:  activeCellsEdit.cnfrmUpift
                    },
                    {
                        id: 'unit',
                        value: fieldValue.unit,
                        className: `cellClass cellClass_${index}_${iIndexes.UNIT}`,
                        width: '200px',
                        readOnly:true,
                        required:true
                    },
                    {
                        id: 'remarks',
                        value: fieldValue.remarks,
                        className: `cellClass cellClass_${index}_${iIndexes.REMARKS}`,
                        width: '200px'
                    }                ]);
                return fieldValue;
            });
            setUpliftSheetData(options);
            if(options){
                setUpliftSheetDataMaster(options);
                const newRows = createEmptySheetRows(pList.length,10);
                setWarehouseItemsFiltered( [...pList, ...newRows ]);
                setWarehouseItemsFull(pList);
                setEditTransferItemsToSheet({items:[...pList]},options)
                }
}else{
setMessage({error:'No Items Found, Redirecting...'})
}

                }
            }
            catch (error) {
                  const errorObj = JSON.parse(error.message);
                setLoading(true);
                setMessage({error:errorObj?.data?.message||'Something went wrong. Please try again after some time.'});
            }
}else{
    try {
        setDateEdited(null);
        filter1 ={
            departureDate:formatDateByTimezone( dateid),
            storeId: Number(sectorid),
            warehouseId: Number(warehouseid)
        }
        filter2={departureDate:formatDateByTimezone( dateid),
            operationDate: formatDateByTimezone( dateid),
            storeId: Number(sectorid),
            warehouseId: Number(warehouseid)}

                const [respEnum,resPriceList,resPriceListEnum] = await Promise.all([
                    APIEndpoint.get('items/enumerate'),
                    APIEndpoint.post(`stores/pricelist/items`,filter1),
                    APIEndpoint.post(`stores/pricelist/items/enumerate`,filter2),
                ],

                );
                if(respEnum.success &&resPriceList.success && resPriceListEnum.success){
                    const pList= resPriceList.items.filter((item,index)=>respEnum.items.find((resI,index)=>resI.itemId===item.itemId)).filter((eIt,index)=>resPriceListEnum.items.find((rIp,index)=>rIp.itemId===eIt.itemId));
        if(pList && pList.length){
        
             setLoading(false)
            const options = [];
            pList.filter( (fieldValue, index) => {
                options.push([
                    {
                        id: 'itemCode',
                        value: fieldValue.itemCode,
                        className: 'cellClass1',
                        width: '300px',
                        showPopup:true,
                        readOnly:false,
                        required:true,
                        type:"string"
                    },
                    {
                        id: 'itemName',
                        value: fieldValue.itemName,
                        className: `cellClass cellClass_${index}_${iIndexes.ITEM_NAME}`,
                        width: '400px',
                        showPopup:true,
                        readOnly:false,
                        required:true,
                        type:"string"
                    },
                    {
                        id: 'availableStock',
                        value: fieldValue.availableStock,
                        className: `cellClass cellClass_${index}_${iIndexes.AVAILABLE_STOCK}`,
                        width: '100px',
                        readOnly: true
                    },
                    {
                        id: 'estimatedQuantity',
                        value: fieldValue.estimatedQuantity,
                        className: `cellClass cellClass_${index}_${iIndexes.ESTIMATED_QTY}`,
                        width: '100px',
                        readOnly: true,
                    },
                    {
                        id: 'bob',
                        value: fieldValue.bob??0,
                        className: `cellClass cellClass_${index}_${iIndexes.BOB}`,
                        width: '100px',
                        readOnly:activeCellsEdit.bob
                    },
                    {
                        id: 'corporate',
                        value: fieldValue.corporate??0,
                        className: `cellClass cellClass_${index}_${iIndexes.CORPORATE}`,
                        width: '100px',
                        readOnly:  activeCellsEdit.corp
                    },
                    {
                        id: 'webMeal',
                        value: fieldValue.webMeal??0,
                        className: `cellClass cellClass_${index}_${iIndexes.WEB_MEAL}`,
                        width: '200px',
                        readOnly:  activeCellsEdit.webMeal
                    },
                    {
                        id: 'adjustments',
                        value: fieldValue.others??0,
                        className: `cellClass cellClass_${index}_${iIndexes.ADJUSTMENTS}`,
                        width: '200px',
                        readOnly: false
                    },
                    {
                        id: 'total',
                        value: fieldValue.total,
                        className: `cellClass cellClass_${index}_${iIndexes.TOTAL}`,
                        width: '200px',
                        readOnly: true
                    },

                    {
                        id: 'totalByWarehouseOfficer',
                        value: fieldValue.totalByWarehouseOfficer,
                        className: `cellClass cellClass_${index}_${iIndexes.TOTAL_WHOFFICER}`,
                        width: '200px',
                        readOnly:  activeCellsEdit.loadWhs
                    },
                    {
                        id: 'totalByCateringOfficer',
                        value: fieldValue.totalByCateringOfficer,
                        className: `cellClass cellClass_${index}_${iIndexes.TOTAL_CATOFFCR}`,
                        width: '200px',
                        readOnly:  activeCellsEdit.cnfrmUpift
                    },
                    {
                        id: 'unit',
                        value: fieldValue.unit,
                        className: `cellClass cellClass_${index}_${iIndexes.UNIT}`,
                        width: '200px',
                        readOnly:true,
                        required:true
                    },
                    {
                        id: 'remarks',
                        value: fieldValue.remarks,
                        className: `cellClass cellClass_${index}_${iIndexes.REMARKS}`,
                        width: '200px'
                    }                ]);
                return fieldValue;
            });
            setUpliftSheetData(options)
            if(options){
                 setUpliftSheetDataMaster(options);
                const newRows = createEmptySheetRows(pList.length,10);
                setWarehouseItemsFiltered( [...pList, ...newRows ]);
                setWarehouseItemsFull(pList);
                setEditTransferItemsToSheet({items:[...pList]},options)
                }
}else{
setMessage({error:'No Items Found, Redirecting...'})
}

                }
            }
            catch (error) {
                const errorObj = JSON.parse(error.message);
                setLoading(true);
                setMessage({error:errorObj?.data?.message||'Something went wrong. Please try again after some time.'});
            }
}


      };


      const setEditTransferItemsToSheet = (transferDetails,options) => {
        let jsonSpreadsheetData = JSON.stringify( options );
        let updatedSpreadsheetData = JSON.parse(jsonSpreadsheetData)
            const items = transferDetails.items;
        if(transferDetails.items &&updatedSpreadsheetData.length){
            items.map( (item, i) => {
                if (updatedSpreadsheetData[i]) {
                    updatedSpreadsheetData[i][iIndexes.ITEM_CODE].value = item.itemCode;
                    updatedSpreadsheetData[i][iIndexes.ITEM_NAME].value = item.itemName;
                    updatedSpreadsheetData[i][iIndexes.AVAILABLE_STOCK].value = item.availableStock;
                    updatedSpreadsheetData[i][iIndexes.ESTIMATED_QTY].value = item.estimatedQuantity;
                    updatedSpreadsheetData[i][iIndexes.BOB].value = item.bob;
                    updatedSpreadsheetData[i][iIndexes.CORPORATE].value = item.corporate;
                    updatedSpreadsheetData[i][iIndexes.WEB_MEAL].value = item.webMeal;
                    updatedSpreadsheetData[i][iIndexes.ADJUSTMENTS].value = item.others;
                    updatedSpreadsheetData[i][iIndexes.TOTAL].value = item.total;
                    updatedSpreadsheetData[i][iIndexes.TOTAL_CATOFFCR].value = item.totalByCateringOfficer;
                    updatedSpreadsheetData[i][iIndexes.TOTAL_WHOFFICER].value = item.totalByWarehouseOfficer;
                    updatedSpreadsheetData[i][iIndexes.UNIT].value = item.unit;
                    updatedSpreadsheetData[i][iIndexes.REMARKS].value = item.remarks;
                    return item;
        }});
        }

        ReactDOM.flushSync( () => {
             setUpliftSheetData( [ ...updatedSpreadsheetData ]);

        });

    };


const getCatManagerCount = (inMgr) => {
  const itemCode = inMgr?.value;
  return itemCode ? warehouseItemsMap[itemCode] || {} : {};
};

    const saveSheetData = async () => {
        const postItems = [];
        setSpreadsheetErrors([]);
            syncUpliftDataMaster([ ...upliftSheetData ],null);
            upliftSheetDataMaster.map( (cellRow, idx) => {
            const catMngrObj= getCatManagerCount(cellRow[iIndexes.ITEM_CODE])
            const itemCode = validateCellAndGetData(cellRow[iIndexes.ITEM_CODE]);
            const itemName = validateCellAndGetData(cellRow[iIndexes.ITEM_NAME]);
            if (!itemCode || !itemName) {
                return false;
            }
            const availableStock = validateCellAndGetData(cellRow[iIndexes.AVAILABLE_STOCK]);
            const estimatedQuantity = validateCellAndGetData(cellRow[iIndexes.ESTIMATED_QTY]);
            const bob = validateCellAndGetData(cellRow[iIndexes.BOB]);
            const corporate = validateCellAndGetData(cellRow[iIndexes.CORPORATE]);
            const webMeal = validateCellAndGetData(cellRow[iIndexes.WEB_MEAL]);
            const others = validateCellAndGetData(cellRow[iIndexes.ADJUSTMENTS]);
            const total = validateCellAndGetData(cellRow[iIndexes.TOTAL]);
            const reviewedByCateringManagerValue = catMngrObj?.totalByCateringManager??0;
            const scannedByWarehouseOfficerValue = validateCellAndGetData(cellRow[iIndexes.TOTAL_WHOFFICER]);
            const verifiedByCateringOfficerValue = validateCellAndGetData(cellRow[iIndexes.TOTAL_CATOFFCR]);
            const remarks = validateCellAndGetData(cellRow[iIndexes.REMARKS]);
            const unit = validateCellAndGetData(cellRow[iIndexes.UNIT]);

            if (itemCode && itemName ) {
                postItems.push({
                    index: idx,
                    itemCode ,
                    itemName,
                    availableStock,
                    estimatedQuantity: Number(estimatedQuantity),
                    bob: Number(bob),
                    corporate: Number(corporate),
                    webMeal: Number(webMeal),
                    others: Number(others),
                    total: Number(total),
                    ...(state?.upliftData === "upliftCreated" && {
                    verifiedByCateringOfficerValue: Number(verifiedByCateringOfficerValue),
                    }),
                    ...(state?.upliftData === "reviewRequestedFromCateringManager" && {
                    reviewedByCateringManagerValue: Number(reviewedByCateringManagerValue),
                    verifiedByCateringOfficerValue: Number(verifiedByCateringOfficerValue),
                    }),
                    ...(state?.upliftData === "awaitingItemScanAndLoad" && {
                    reviewedByCateringManagerValue: Number(reviewedByCateringManagerValue),
                    scannedByWarehouseOfficerValue: Number(scannedByWarehouseOfficerValue),
                    verifiedByCateringOfficerValue: Number(verifiedByCateringOfficerValue),
                    }),
                    ...(remarks.length>0?{remarks:remarks}:{}),
                    unit:unit,
                });
            return cellRow;

            }
            else {
                /**
                 * SET Error status
                 */
                // cellRow[iIndexes.ITEM_UNIT].className += ' errorCellData';
                // cellRow[iIndexes.ITEM_REQ_QTY].className= 'errorCellData';
                // cellRow[iIndexes.ITEM_RECI_QTY].className= 'errorCellData';
                // cellRow[iIndexes.ITEM_QTY].className= 'errorCellData';
                // cellRow[iIndexes.ITEM_REMARKS].className= 'errorCellData';

                setSpreadsheetErrors([ { message: 'Please fill all required item details.', error: 1} ]);
                return false
            }

        });
        if (postItems.length === 0) {
            setSpreadsheetErrors([ ...spreadsheetErrors, { message: 'We did not find anything to save!' } ]);
            return false;
        }
        let data;

        if(warehouseid !== undefined){
            data ={
                flightDate: formatDateByTimezone(dateid),
                storeId: Number(sectorid),
                warehouseId: Number(warehouseid),
                items: postItems
            }
        }else{
            let IdData = await findByIdData();
            data = {
                upliftId: id,
                warehouseId: IdData.result.warehouseId,
                storeId: IdData.result.storeId,
                flightDate: formatDateByTimezone(IdData.result.dateModified),
                items: postItems
            }
        }
        APIEndpoint.post('uplifts/save', data)
        .then( apiResp => {
            setSpreadsheetErrors([ ...spreadsheetErrors, { message: apiResp?.message || 'Successfully created Uplift.' } ]);
            setTimeout(() => {
                goToInventory()
            }, 1000);
        })
        .catch( (error) => {
            const apiData = JSON.parse(error.message).data;
            if ( apiData.errors ) {
                const errorMsg = apiData.errors.errors[0].message;
                setSpreadsheetErrors([ ...spreadsheetErrors, { message: errorMsg, error: 1 } ]);
            }
            else if (apiData.msg || apiData?.message) {
                const saevErrorMessage  = apiData.msg || apiData?.message;
                setSpreadsheetErrors([ ...spreadsheetErrors, { message:saevErrorMessage, error: 1 } ]);
            }
        });

    };



    const setWarehouseTransferItemToSheet = (item) => {
        if (Object.keys(item).length === 0) {
            return 0;
        }

        let jsonSpreadsheetData = JSON.stringify( upliftSheetData );
        let updatedSpreadsheetData = JSON.parse(jsonSpreadsheetData);

        updatedSpreadsheetData.map( (sheetRow, i) => {
            if (i === activeCell.row) {

                sheetRow[iIndexes.ITEM_CODE].value = item.itemCode;
                sheetRow[iIndexes.ITEM_NAME].value = item.itemName;
                sheetRow[iIndexes.AVAILABLE_STOCK].value = '';
                sheetRow[iIndexes.ESTIMATED_QTY].value ='';
                sheetRow[iIndexes.BOB].value = '';
                sheetRow[iIndexes.CORPORATE].value = '';
                sheetRow[iIndexes.WEB_MEAL].value = '';
                sheetRow[iIndexes.ADJUSTMENTS].value = '';
                sheetRow[iIndexes.TOTAL].value = '';
                sheetRow[iIndexes.TOTAL_CATOFFCR].value = '';
                sheetRow[iIndexes.TOTAL_WHOFFICER].value = '';
                sheetRow[iIndexes.UNIT].value = item.unit;
                sheetRow[iIndexes.REMARKS].value = '';
            }

            return sheetRow;
        } );


        ReactDOM.flushSync( () => {
            // let newRows=createEmptySheetRows(null,10);
              setUpliftSheetData( [ ...updatedSpreadsheetData ]);

         });

        setActiveCell({});
        hidePopupList();
    }


    const onClickPopupListItem = (e, row, type='reason') => {

        if (type === 'reason') {
            setReasonField(row);
        }
        else {
            setWarehouseTransferItemToSheet(row);
        }
    }

    const selectAllCells = (e) => {
        setCount((prev)=>prev+1)
        let updatedSheetData=[]
        if(count%2!==0){
            updatedSheetData = upliftSheetData.map((row, rowIndex) => {
                return row.map((cell, colIndex) => {
                    return {
                        ...cell,
                        className: `selectcell-class cellClass cellClass_${rowIndex}_${colIndex}`
                    };
                });
            });
        }else{
            updatedSheetData = upliftSheetData.map((row, rowIndex) => {
                return row.map((cell, colIndex) => {
                    return {
                        ...cell,
                        className: `cellClass cellClass_${rowIndex}_${colIndex}`
                    };
                });
            });
        }

    setUpliftSheetData(updatedSheetData);

    };


    const showItemListPopup = (eltPosition, activeCellIn) => {
        if (activeCellIn.column === iIndexes.ITEM_CODE) {
            if (targetEltCodes) {
                targetEltCodes.style.display = 'block';
                targetEltCodes.style.top = ( eltPosition.height + eltPosition.top + 2 ).toFixed() + 'px';
                targetEltCodes.style.left = eltPosition.left.toFixed() + 'px';
            }
        } else if (activeCellIn.column === iIndexes.ITEM_NAME) {
            if (targetEltNames) {
                targetEltNames.style.display = 'block';
                targetEltNames.style.top = ( eltPosition.height + eltPosition.top + 2 ).toFixed() + 'px';
                targetEltNames.style.left = eltPosition.left.toFixed() + 'px';
            }
        }
    }


    const hidePopupList = () =>{
        // if (activeCell.column === iIndexes.ITEM_CODE) {
            if (targetEltCodes) {
                targetEltCodes.style.display = 'none';
            }
        // } else if (activeCell.column === iIndexes.ITEM_NAME) {
            if (targetEltNames) {
                targetEltNames.style.display = 'none';
            }
        // } else if (activeCell.column === iIndexes.ITEM_NAME) {
            if ( targetEltReasonTypes ) {
                targetEltReasonTypes.style.display = 'none';
            }
        // }
    }

    const setReasonField = (reason) => {
        if (Object.keys(reason).length === 0) {
            return 0;
        }

        let jsonSpreadsheetData = JSON.stringify( upliftSheetData );
        let updatedSpreadsheetData = JSON.parse(jsonSpreadsheetData);

        updatedSpreadsheetData.map( (sheetRow, i) => {
            if (i === activeCell.row) {
                sheetRow[iIndexes.ITEM_REASON].value = reason.label;
            }

            return sheetRow;
        } );


        ReactDOM.flushSync( () => {
            setUpliftSheetData( [ ...updatedSpreadsheetData ]);
        });

        setActiveCell({});
        hidePopupList();
    }

    const handleActiveCellChange = (activeCell) => {
        setActiveCell({});
        hidePopupList();
        setActiveCell(activeCell);

        if (!loading && upliftSheetData[activeCell.row][activeCell.column] ) {
            const cellDetailsObj = upliftSheetData[activeCell.row][activeCell.column];
            if ( cellDetailsObj.hasOwnProperty('showPopup') && cellDetailsObj.showPopup === true ) {

                const sourceElt = document.getElementsByClassName('cellClass_' + activeCell.row + '_' + activeCell.column)[0];
                if ( sourceElt ) {
                    const eltPosition = sourceElt.getBoundingClientRect();

                    showItemListPopup(eltPosition, activeCell);
                }

            }

        }

    }
    const handleCellBlur = () => {
        console.log('CellBlur.');
    }

    const handleCellKeyDown = (keyboardEvent) => {

        const searchText = keyboardEvent.target.value;
        if (activeCell && Object.keys(activeCell).length > 0) {
            if (upliftSheetData[activeCell.row][activeCell.column].type === 'number' &&  keyboardEvent.target.value ) {
                keyboardEvent.target.value = keyboardEvent.target.value.replace(/[^0-9]$/g, '');
            }
        }

        // const eltPosition = keyboardEvent.target.getBoundingClientRect();
        // showItemListPopup(eltPosition);

        /**
         * Filter poup items
         */
        const searchPattern = new RegExp((searchText || '').replace(/[.*+?^=!:${}()|[\]\\]/g, '\\$&'),'gi');
        const filteredList = warehouseItemsFull?.filter( row => row.itemCode.search( searchPattern ) !== -1 );
        setWarehouseItemsFiltered([ ...filteredList ]);
    }

    const handleCellSelect = (selectedCell) => {
        if (selectedCell.length !== 0) {
            setSelectedCellsArr([ ...selectedCell ]);
        }
    };
    function goToInventory() {
        navigate("/inventory/uplifts")
      }
    function goBack() {
       navigate(-1);
    }

function calcTotal(data) {

  let jsonSpreadsheetData = JSON.stringify(data);
  let SpreadsheetData = JSON.parse(jsonSpreadsheetData).filter(row => row[0] !== undefined);

  const updatedSpreadsheetData = SpreadsheetData.map((sheetRow, i) => {
    const updatedSheet = sheetRow.filter(item => item !== null).map(cell => {
      if (cell === null) {
        return cell;
      }
      if (cell && (cell.id === 'bob' || cell.id === 'webMeal' || cell.id === 'corporate') && isNaN(cell?.value)) {
        return { ...cell, value: "" }; 
      }
      return cell;
    });

    const totalValue = [4, 5, 6, 7].reduce((sum, index) => {
      const value = Number(updatedSheet[index]?.value) || 0;
      return sum + value;
    }, 0);

    updatedSheet[iIndexes.TOTAL] = { ...updatedSheet[iIndexes.TOTAL], value: totalValue };

    return updatedSheet;
  });

  const newDataIsDifferent = JSON.stringify(updatedSpreadsheetData) !== JSON.stringify(upliftSheetData);
  
  if (newDataIsDifferent) {
    setUpliftSheetData(updatedSpreadsheetData);
  }
}


    return (
        <>
            <div className="op-aircraft-container flexCol full-flex ag-theme-alpine-dark">
             { !loading && !message?.error?.length? <>
                    <div className="header mb-2 flexRow justifyContentSpaceBetween">
                        <div className="leftBlock alignItemsCenter flexRow">
                        <button onClick={ (e) => saveSheetData(e) }
                                className="alignItemsCenter add-item-button mr-2"><FaSave style={{marginRight:'5px',marginBottom:"2px"}}/>{ t('buttons.save') }</button>
                                {checkSheetData()?<><button onClick={ (e) => selectAllCells(e) }
                                className="alignItemsCenter flexRow add-item-button-all m-3">{count%2===0?<BiSolidSelectMultiple  style={{marginRight:'5px'}} />:<FaRegCheckSquare  style={{marginRight:'5px'}} />}Select All</button><button onClick={ () => removeRow() }
                                className="remove-button"> <RiDeleteBin6Line style={{ marginRight: "5px" ,marginBottom:"3px" }} />Delete Row</button></>:<></> }&nbsp;
                                    <div className='flexRow justifyContentFlexStart width60 scanner-sel' style={{maxHeight:'2.4rem'}} >
                                    <button className={filterItemsType.all.checked?'niO4u-checked':'niO4u'} disabled={!filterItemsType.all.count} onClick={()=>handleTypeSelect('all')}>
                                    All&nbsp;({filterItemsType.all.count})
                                    </button>
                                    <button  className={filterItemsType.dutyFree.checked?'niO4u-checked':'niO4u'} disabled={!filterItemsType.dutyFree.count} onClick={()=>handleTypeSelect('dutyFree')}>
                                    Duty Free&nbsp;({filterItemsType.dutyFree.count})
                                    </button>
                                    <button className={filterItemsType.dutyPaid.checked?'niO4u-checked':'niO4u'} disabled={!filterItemsType.dutyPaid.count}  onClick={()=>handleTypeSelect('dutyPaid')}>
                                    Duty Paid&nbsp;({filterItemsType.dutyPaid.count})
                                    </button>
                                    </div>
                                                            </div>
                        {spreadsheetErrors.length >= 1? <div className={`padding4 margTop9-5 alert alert-${spreadsheetErrors[0].message.includes('fully') ? 'success' : 'danger'}`}>
                        {spreadsheetErrors.length >= 1 ? spreadsheetErrors[0]?.message : null}
                        </div>:null}
                        <button onClick={goBack}>
                          <img src={closeIcon} alt="close" data-icon='close'/>
                        </button>
                    </div>
                    <div className="se-titlebar">
                    {sectorName ? `Uplift New* - ${sectorName}- ${dateid?moment.parseZone(dateid).format("DD/MM/YYYY"):moment.parseZone(dateEdited).format("DD/MM/YYYY")}`:""}
                   </div>
                   <div className="sheet-container sm-scrollbar pilferageCreate">    
                     <ReactSpreadsheet
                   
                        data={upliftSheetData}
                        onChange={calcTotal}
                        columnLabels={upliftsSheetLabels}
                        darkMode={true}
                        // getBindingsForCell={[]}
                        onActivate={handleActiveCellChange}
                        onBlur={handleCellBlur}
                        onKeyDown={handleCellKeyDown}
                        onSelect={handleCellSelect}
                        cellClassName="custom-cell"

                    />
                    </div>

                    {loading && (
                        <div style={{display:"flex",justifyContent:"center",height:"20vh",alignItems:"center"}}>Loading data...</div>
                    )}


                    <div className="flexRow alignItemsCenter margTop8">
                        <button onClick={ () => addRowsToSheet() }
                            className="add-item-button" title={ t('spreadsheet.addmoreRows') }>{ t('buttons.addRows') }</button>
                    </div>
             </>
                    :
                    <LoaderPop/>
}
                    <div className = "cellSelectionBlockItemCodes sm-scrollbar">
                {
                    warehouseItemsFiltered.length ? (
                    <ul>
                        {warehouseItemsFiltered.length && warehouseItemsFiltered.filter(item => !Array.isArray(item)).map( (row, i) => (
                            <li key={ i } onClick={ (e) => onClickPopupListItem(e, row, 'item') }>{ row.itemCode }</li>
                        ) )
                        }
                    </ul>
                    )
                    : null
                }
                </div>
                <div style={{minWidth: '280px'}} className = "cellSelectionBlockItemNames sm-scrollbar">
                {
                    warehouseItemsFiltered.length ? (
                    <ul>
                        {warehouseItemsFiltered.length && warehouseItemsFiltered.filter(item => !Array.isArray(item)).map( (row, i) => (
                            <li key={ i } onClick={ (e) => onClickPopupListItem(e, row, 'item') }>{ row.itemName }</li>
                        ) )
                        }
                    </ul>
                    )
                    : null
                }
                </div>
                   <ToastContainer/>
            </div>
        </>
    );
}
